export const deviceNamePrefix = 'Dispositivo ';
export const endDatePrefix = 'Fecha de fin de arrendamiento: ';
export const quotePrefix = 'Cuota: ';
export const mobileRent2RentNotContractedText = 'pendiente';
export const moreInformation = 'Más información';
export const requestNow = 'Solicitar ahora';
export const inProcessOrder = 'En proceso de envío';
export const moreOneR2R = 'Tienes 2 dispositivos Fusión';
export const moreOneR2RPikolin = 'Tienes 2 dispositivos miMovistar';
export const addMoreOneR2R = 'Dispositivo adicional';
export const othersPendingOrder = 'Tienes un dispositivo pendiente de envío';
export const equipmentSubtitleIncludedOrder = 'Pide tu dispositivo incluido';
export const equipmentSubtitleAditionaldOrder =
  'Pide tu dispositivo adicional.';

export const chooseSmartphoneTitleModal = 'Pendiente de elección';
export const chooseSmartphoneTitle2Modal = 'Elige ahora tu dispositivo';
export const chooseSmartphoneDescriptionModal =
  'Puedes seleccionar tu dispositivo incluido sin coste adicional en el catálogo disponible. También puedes elegir un dispositivo de gama superior con un coste extra al mes.';

export const pendingMobileTitleModal =
  'Tu dispositivo está en proceso de envío';
export const pendingMobileDescriptionModal =
  'Tu pedido se ha tramitado y en breve nos pondremos en contacto contigo para concretar la entrega.<br><br>Si lo deseas, puedes consultar su estado desde <br><a class="blueLink" style="color: #0066FF !important;" href="https://www.movistar.es/cliente/areaprivada/#/misDatos/seguimientoDePedido">seguimiento de pedidos</a>.';
export const pendingMobileDescriptionModalPikolin =
  'Tu pedido se ha tramitado y en breve nos pondremos en contacto contigo para concretar la entrega.<br><br>Si lo deseas, puedes consultar su estado desde seguimiento de pedidos.';

export const notHaveDeviceR2Ryet = 'Todavía no tienes ningún dispositivo miMovistar';
export const notHaveDeviceR2RyetFusion = 'Todavía no tienes ningún dispositivo Fusión';

export const serverErrorText = {
  errorAlt1: 'error',
  errorTitle1:
    'Estamos trabajando para ofrecerte la información que has solicitado',
  errorAlt2: 'error',
  errorMessage2: 'Por favor, inténtalo de nuevo más tarde',
  errorTitle2: 'No podemos mostrarte la información en este momento',
  errorMessage3:
    'Si eres titular, cierra sesión y  vuelve a entrar con contraseña',
  errorAlt3: 'Solo titular',
  errorLabelButton3: 'Cerrar sesión',
  errorLink3: '/misDatos',
  errorTitle3: 'Información solo disponible para el titular de la línea',
  errorMessageNoUsages:
    'Cuando tengas consumos te mostraremos aquí el detalle para que puedas consultarlo',
  errorTitleNoUsages: 'No has realizado ningún consumo',
  errorAltNoUsages: 'No hay consumo',
  errorMessageNoTracking:
    'Cuando tengas algún pedido te mostraremos aquí el detalle para que puedas consultarlo',
  errorTitleNoTracking: 'Si haces algún pedido podrás verlo aquí.',
  errorAltNoTracking: 'No hay pedidos',
  errorMessageNoMovement:
    'Cuando tengas movimientos te mostraremos aquí el listado para que puedas consultarlo',
  errorTitleNoMovement: 'No has realizado ningún movimiento',
  errorAltNoMovement: 'No hay movimiento',
  errorExtraExpensesTitle: 'No tienes consumos de este tipo en este periodo',
  errorExtraExpensesSubtitle:
    'Aquí verás el detalle de gastos extra durante el ciclo de facturación',
};

export const searcherText = {
  placeholder: 'Escribe aquí tu pregunta',
};

export const upgradeInternetSpeedText = {
  label1Gb: 'Sube la velocidad de tu fibra hasta 1 Gb',
  label300Mb: 'Sube la velocidad de tu fibra a 300 Mb',
  taggingClassUpgrade1Gb: 'modal-subida-1Gb',
  taggingClassLegalCondition1Gb: 'modal-condiciones-subida-1Gb',
  taggingClassUpgrade300Mb: 'modal-subida-300Mb',
  taggingClassLegalCondition300Mb: 'modal-condiciones-subida-300Mb',
  textTitle1Gb:
    'Navega sin límites hasta 1 Gb y disfruta de la máxima velocidad en fibra.',
  textTitle300Mb:
    'Movistar sube la velocidad de tu fibra para que navegues sin límites aún más rápido.',
  labelButton1Gb: 'Finalizar',
  labelButton300Mb: 'Finalizar',
  idButton1Gb: 'sube-hasta-1Gb',
  idButton300Mb: 'sube-a-300Mb',
  textLegalCondition1Gb:
    'Al continuar estás aceptando que la velocidad de navegación de tu fibra pase a ser de hasta 1 Gb sin alterar ningún otro componente de tu producto. Puedes consultar las condiciones del producto que tienes contratado en ',
  textLegalCondition300Mb:
    'Al continuar estás aceptando que la velocidad de navegación de tu fibra pase a ser de 300 Mb sin alterar ningún otro componente de tu producto. Puedes consultar las condiciones del producto que tienes contratado ',
  textAlertUpgrade1Gb:
    'La subida de velocidad de tu fibra hasta 1 Gb se hará efectiva en los próximos minutos.',
  textAlertUpgrade300Mb:
    'La subida de velocidad de tu fibra a 300 Mb se hará efectiva en los próximos minutos.',
};

export const ProductInfoTexts = {
  pricePrefix: 'Desde ',
};

export const buttonLabel = {
  accept: 'Aceptar',
  cancel: 'Cancelar',
  continue: 'Continuar',
  finish: 'Finalizar',
};
export const contactEmailLabel = {
  incorrectFormatEmail: 'Formato de email incorrecto',
  inputInfo:
    'Este mail será tu único mail de contacto para todas tus comunicaciones con Movistar',
  modifiedContactError: 'No se ha podido actualizar el email',
};
export const modalStepInfo = {
  emailRequired:
    'Para continuar necesitamos enviarte por mail el resumen de las condiciones.',
  mailNoticeSent:
    'Te hemos enviado un mail con el resumen de las condiciones de contratación.',
  label: 'Resumen de contrato',
  prepaidInfo:
    'Si quieres, antes de continuar puedes descargar un resumen de las condiciones para conservarlas en pdf. Son vinculantes para Movistar si completas la compra en este momento.',
};

export const billClaimText = {
  noBills: 'No tienes ninguna factura reclamada en el último año.',
  searchInputPlaceholder: 'Introduce el identificador de factura o reclamación',
  searchInputPlaceholderMobile: 'Id de factura o reclamación',
  dropdownText: 'Factura reclamada',
  dropdownTextMobile: 'Fact. reclamada',
  searchById: 'Identificador',
  searchByDate: 'Fecha',
  initDate: 'Fecha de inicio',
  endDate: 'Fecha de fin',
  searchButtonText: 'Buscar',
  genericIdSearchError: 'No hemos encontrado ningún resultado. Sólo puedes buscar las facturas y reclamaciones del último año.',
  genericDateSearchError: 'No tienes ninguna factura reclamada entre las fechas seleccionadas.',
  moreThanYearDateError: 'Solo podemos mostrarte las facturas y reclamaciones del último año. Si lo necesitas, contáctanos en el 1004 o acude a una tienda Movistar.',
  orderByDate: 'Ordenar por fecha',
  orderByPrice: 'Ordenar por precio',
  preTitleText: '',
  priceTitle: 'Importe',
  phaseOpen: 'En curso',
  phaseAnnulled: 'Anulada',
  phaseClosed: 'Finalizada',
  initText: 'Inicio',
  endText: 'Fin',
  statusOpen: 'Abierto',
  statusOngoing: 'En curso',
  statusResolution: 'En resolución',
  statusEnded: 'Finalizada',
  statusAnnulled: 'Anulado',
  statusCanceled: 'Anulada',
  //claimPrice: 'Importe reclamado',
  claimPrice: 'Resolución',
  claimPricePending: 'En análisis',
  claimPriceAccepted: 'Favorable',
  claimPriceRejected: 'Desfavorable',
  //returnPrice: 'Importe a devolver',
  returnPrice: 'Importe a tu favor',
  returnPriceMobile: 'Imp. a tu favor',
  taxText: 'Impuestos no incl.',
  onlyThirdInfo: 'La devolución del importe correspondiente se hará en una de tus próximas facturas.',
  thirdInfo: 'La devolución tiene un importe adicional a tu favor que recibirás en una de tus próximas facturas.',
  detailText: 'Ver detalle',
  notifyText: 'Ver notificaciones',
  watchBill: 'Ver factura',
  openNewClaim: 'Abrir nueva reclamación',
  restoreSearch: 'Ver todas',
  modalDescriptionGlobal: 'La devolución del importe correspondiente a los conceptos reclamados se realizará de forma conjunta en una de tus próximas facturas.',
  infoBillsNormal: 'reclamada',
  infoBillsFinded: 'encontrada',
};

export const TEXT_NOT_PRODUCTS = "Todavía no tienes ningún producto contratado"

export const R2R_BANNER_MY_PRODUCTS_ICON = "movil-add-m"
export const R2R_BANNER_MY_PRODUCTS_LABEL = `<span style="color: #0066FF;">Añade nuevo dispositivo</span>`
export const R2R_BANNER_MY_PRODUCTS_NO_DEVICE_LABEL = `<span style="color: #0066FF;">Añade nuevo dispositivo</span>`
export const R2R_BANNER_MY_PRODUCTS_LINK = "https://www.movistar.es/moviles/"
export const R2R_BANNER_MY_PRODUCTS_LINK_SORT = "https://www.movistar.es/moviles/?sort=priceAsc"
export const SUBTITLE_PRODUCT_CARD_NO_DEVICE = "No tienes dispositivos en tu pack"
export const NON_DEVICE_DESCRIPTION = "Te mostramos una selección de dispositivos que te pueden interesar. Elige el tuyo."

export const movistarLiteAlert = {
  title: 'Tienes pendiente crear tu cuenta de Movistar Plus en movistarplus.es',
  description: '',
  linkLabel: 'Crear cuenta',
  link: '',
}
